/*LIBRARY*/
import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "@mui/material";

/*COMPONENT*/
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";
import RegisterStep3Page1 from "./RegisterStep3Page1";
import RegisterStep3Page2 from "./RegisterStep3Page2";
import { Modal } from "../reuseable";

/*REDUX*/
import {
  logoutUser,
  registerUser,
  setErrors,
  usernameCheck,
} from "../../App/actions/authActions";
import {
  check_collaborators,
  join_collab_by_accesstoken,
} from "../../App/actions/license_actions";

/*PICTURE*/

/*FUNCTION*/
import capitalize_first_letter from "../../App/validation/capitalize_first_letter";
import { get_country_calling_codes } from "../../App/validation/countries";

/*DATA*/
import dict from "../../Data/dict.json";
import domain_list from "../../Data/domain_list";

const pages = [
  {
    step: 1,
    field_name: "organization",
  },
  {
    step: 1,
    field_name: "country",
  },
  {
    step: 2,
    field_name: "industry",
  },
  {
    step: 2,
    field_name: "objective",
  },
  {
    step: 3,
    field_name: "first_name",
  },
  {
    step: 3,
    field_name: "last_name",
  },
  {
    step: 3,
    field_name: "name",
  },
  {
    step: 4,
    field_name: "phone_number",
  },
  {
    step: 4,
    field_name: "password",
  },
  {
    step: 4,
    field_name: "password2",
  },
];
const phoneNumberList = get_country_calling_codes();

const Register = ({ registration_step, set_registration_step, kode, mode }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const auth = useSelector((state) => state.auth);
  const errors_from_store = useSelector((state) => state.errors);

  const [state, set_local_state] = useState({
    first_name: "",
    last_name: "",
    name: "",
    email: "x",
    phone_number: "",
    phone_code: "62", // <--- ADD THIS: Default code
    password: "",
    password2: "",
    errors: {},
    industry: "",
    redeem_code: "",
    // show_password: false,
    organization: "",
    country: "Indonesia",
    objective: "",
    code: "",

    modal_collab_confirmation: false,
    modal_full_member: false,
    collaborators: null,
    modal_you_already_member: false,
  });

  // Helper to merge state like class components
  const set_state = (new_values) => {
    set_local_state((prev) => ({ ...prev, ...new_values }));
  };

  const {
    first_name,
    last_name,
    name,
    email,
    phone_number,
    phone_code, // <--- Destructure it
    password,
    password2,
    industry,
    redeem_code,
    organization,
    country,
    objective,
    errors,
    modal_collab_confirmation,
    modal_full_member,
    collaborators,
    modal_you_already_member,
  } = state;

  const { step } = registration_step;

  const redirect_to_dashboard = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete("code");
    const str = params.toString();
    if (str) history.push(`/?${str}`);
    else history.push(`/`);
  }, [history, location.search]);

  const toggle_modal_collab_confirmation = () => {
    set_state({
      modal_collab_confirmation: !modal_collab_confirmation,
    });
  };

  const toggle_modal_you_already_member = () => {
    set_state({
      modal_you_already_member: !modal_you_already_member,
    });
  };

  const toggle_modal_full_member = useCallback(() => {
    set_local_state((prev) => ({
      ...prev,
      modal_full_member: !prev.modal_full_member,
    }));
  }, []);

  const confirmation = useCallback(async () => {
    // const currentSearchParams = new URLSearchParams(window.location.search);
    // const code = currentSearchParams.get("code");
    // const token = localStorage.token_mapid;
    // if (code) {
    //   const collaborators = await this.props.check_collaborators(code);
    //   if (collaborators) {
    //     if (!collaborators?.is_full) {
    //       if (token && this.props.auth?.user) {
    //         if (!collaborators?.is_already_member)
    //           this.toggle_modal_collab_confirmation();
    //         else {
    //           this.toggle_modal_you_already_member();
    //         }
    //       }
    //     } else {
    //       this.toggle_modal_full_member();
    //     }
    //     this.setState({ collaborators })
    //   }
    // } else if (token && this.props.auth?.user) {
    //   this.redirect_to_dashboard();
    // }

    const code_param = new URLSearchParams(location.search).get("code");
    const token = localStorage.token_mapid;
    const isAuthenticated = Boolean(token && auth?.user);

    // jika tidak ada code di URL
    if (!code_param) {
      if (isAuthenticated) redirect_to_dashboard();
      return;
    }

    const collaborators_data = await dispatch(check_collaborators(code_param));
    if (!collaborators_data) return;

    // kondisi ketika kuota penuh
    if (collaborators_data.is_full) {
      toggle_modal_full_member();
    } else if (isAuthenticated) {
      // user login & masih ada slot
      if (!collaborators_data.is_already_member) {
        set_local_state((prev) => ({
          ...prev,
          modal_collab_confirmation: !prev.modal_collab_confirmation,
        }));
      } else {
        set_local_state((prev) => ({
          ...prev,
          modal_you_already_member: !prev.modal_you_already_member,
        }));
      }
    }

    set_state({ collaborators: collaborators_data });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    auth?.user,
    dispatch,
    location.search,
    redirect_to_dashboard,
    toggle_modal_full_member,
  ]);

  // ORIGINAL CODE
  useEffect(() => {
    confirmation();

    const domain = auth.domain;
    const object_domain = domain_list?.[domain];
    // eslint-disable-next-line no-unused-vars
    const {
      organization: org = "",
      objective: obj = "",
      industry: ind = "",
    } = object_domain || {};

    set_state({
      organization: org,
      objective: obj,
      industry: ind,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Equivalent to componentDidMount

  // Error Sync
  useEffect(() => {
    if (JSON.stringify(errors_from_store) !== JSON.stringify(errors)) {
      set_state({
        errors: errors_from_store,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors_from_store]);

  // Country Change Sync
  // CHANGE 1: Update Country Sync to set CODE, not combined number
  useEffect(() => {
    const found_phone = phoneNumberList.find(
      (item) => item.country_name === country,
    )?.calling_code;

    if (found_phone) {
      set_state({
        phone_code: found_phone, // Set the code separately
        // phone_number: "" // Optional: clear number on country change
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  const join_collab_by_token = async () => {
    const currentSearchParams = new URLSearchParams(location.search);
    const code_param = currentSearchParams.get("code");
    const { user } = auth;
    const _id = user._id;
    if (code_param) {
      await dispatch(
        join_collab_by_accesstoken({
          collab_code: code_param,
          _id,
        }),
      );
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const params = {};
    location.search
      .slice(1)
      ?.split("&")
      ?.forEach((item) => {
        const param = item?.split("=");
        const key = param?.[0];
        const value = param?.[1];
        params[key] = value;
      });
    const collab_code = params?.code;

    // Combine code + number for the standard field
    const combined_phone_number = `${phone_code}${phone_number}`;

    let body = {
      full_name: `${first_name} ${last_name}`,
      name: name.toLowerCase().replace(/\s/g, ""),
      email,
      phone_number: combined_phone_number, // Sends 62812345...
      phone_number_only: phone_number, // <--- NEW: Sends only 812345...
      password,
      password2,
      industry: industry,
      city: "Kota Bandung",
      organization,
      country,
      objective,
      collab_code,
    };

    if (kode) {
      body = {
        full_name: `${first_name} ${last_name}`,
        name: name.toLowerCase().replace(/\s/g, ""),
        email,
        phone_number: combined_phone_number, // Sends 62812345...
        phone_number_only: phone_number, // <--- NEW: Sends only 812345...
        password,
        password2,
        industry: mode === "personal" ? "Research and Education" : industry,
        specialist_code: kode,
        city: "Kota Bandung",
        organization,
        country,
        objective,
        collab_code,
      };
    }

    if (collab_code) {
      const collaborators_res = await dispatch(
        check_collaborators(collab_code),
      );
      if (collaborators_res) {
        set_state({ collaborators: collaborators_res });

        if (!collaborators_res?.is_full) {
          await dispatch(registerUser(body, redeem_code));
        } else {
          toggle_modal_full_member();
        }
      }
    } else {
      await dispatch(registerUser(body, redeem_code));
    }
  };
  const remove_error = (key) => {
    const new_errors = structuredClone(state.errors);
    delete new_errors[key];
    set_state({ errors: new_errors });
  };

  const error_handle = (field_name, value) => {
    const language = localStorage?.language ? localStorage?.language : "ina";
    if (!value) {
      const field_name_string = capitalize_first_letter(
        String(field_name),
      ).replaceAll("_", " ");
      if (field_name_string) {
        const text = dict[`${field_name_string} cannot be empty.`][language];
        return { field_name, text };
      }
    } else {
      remove_error(field_name);
    }
  };

  const onChange = (e) => {
    let body = {};
    if (e.target.name === "name") {
      body = {
        [e.target.name]: e.target.value.replace(/\s/g, ""),
        errors: {
          ...state.errors,
        },
      };
    } else {
      body = {
        [e.target.name]: e.target.value,
        errors: {
          ...state.errors,
        },
      };
    }

    delete body.errors[e.target.name];
    set_state(body);
    dispatch(setErrors());
    error_handle(e.target.name, e.target.value);
  };

  const check_if_any_error = () => {
    // cari error yang belum diketahui
    let errors_local = [];
    let error_texts = {};
    pages
      .filter((page) => page.step <= step)
      .forEach((field) => {
        const is_empty = !state?.[field.field_name];
        if (is_empty) {
          const { field_name, text } =
            error_handle(field?.field_name, !!state?.[field?.field_name]) || {};

          error_texts[field_name] = text;
          errors_local.push(field);
        }
      });

    if (errors_local?.length > 0) {
      set_state({
        errors: error_texts,
      });

      set_registration_step({
        step: errors_local?.[0]?.step,
      });
      return errors_local?.[0]?.step;
    }
    return false;
  };

  const set_page_to_error = () => {
    // cek error yang sudah ada di state, kemudian ke halaman error tersebut
    for (let page of pages) {
      if (state.errors?.[page.field_name]) {
        set_registration_step({
          step: page.step,
        });
        break;
      }
    }
  };

  const name_cb = async (e) => {
    const name_val = e.target.value;
    if (name_val) {
      await dispatch(usernameCheck(name_val));
    }
  };

  const language = localStorage?.language ? localStorage?.language : "ina";

  // const industry_list = get_industries(language);

  // const industry_list_sorted = sortArray(industry_list, "title", true);

  const { loading } = auth;
  const your_name = auth?.user?.full_name || auth?.user?.name || "";

  let iconButton;
  let kode_content;
  if (kode) {
    kode_content = (
      <section style={{ marginBottom: "10px" }}>
        Kode specialist: <b>{kode}</b>
      </section>
    );
  }
  if (loading) {
    iconButton = (
      <button
        className="button background_black"
        type="submit"
        style={{
          padding: "5px 15px",
          backgroundColor: "#1265ae",
          marginTop: "1rem",
        }}
      >
        {dict["Registering..."][language]}
      </button>
    );
  } else {
    iconButton = (
      <button
        className="marginTop_20 rounded_5 bg_black text_white w_full h_50"
        type="submit"
        data-mapid="clickNext"
        onClick={async (e) => {
          if (Object.keys(errors)?.length > 0) {
            set_page_to_error();
          } else {
            if (step < 4) {
              const is_any_error = check_if_any_error();
              if (is_any_error) {
                //ada error
                set_registration_step({
                  step: is_any_error,
                });
              } else {
                //kalo nggak ada error
                set_registration_step({
                  step: registration_step?.step + 1,
                });
              }
            } else if (step === 4 && Object.keys(errors)?.length === 0) {
              onSubmit(e);
            }
          }
        }}
      >
        {step === 4 ? dict["Register"][language] : dict["Next"][language]}
      </button>
    );
  }

  let page_content = null;
  if (step === 1) {
    page_content = (
      <RegisterStep1
        country={country}
        organization={organization}
        onChange={onChange}
        errors={errors}
      />
    );
  } else if (step === 2) {
    page_content = (
      <RegisterStep2
        industry={industry}
        objective={objective}
        onChange={onChange}
        errors={errors}
      />
    );
  } else if (step === 3) {
    page_content = (
      <RegisterStep3Page1
        first_name={first_name}
        last_name={last_name}
        name={name}
        onChange={onChange}
        errors={errors}
        name_cb={name_cb}
      />
    );
  } else if (step === 4) {
    page_content = (
      <RegisterStep3Page2
        country={country}
        phone_number={phone_number}
        phone_code={phone_code} // <--- Pass the code
        set_state={set_state} // <--- Pass the setter
        password={password}
        password2={password2}
        onChange={onChange}
        errors={errors}
      />
    );
  }

  const register_content = (
    <div>
      {kode_content}
      <div>
        {page_content}
        {iconButton}
      </div>
      <style>{`
           #bottom_bar{ display:none;}
        `}</style>
    </div>
  );

  // const default_content = (
  //   <div className="flex flex_col gap_10">
  //     <label>
  //       {dict["Select your account mode you want to register"][language]}
  //     </label>
  //     <section className="flex justify_center gap_10">
  //       <button
  //         className="button_inactive border padding_5 rounded_5 text_blue"
  //         onClick={() => handle_mode("personal")}
  //         data-mapid="clickPersonal"
  //       >
  //         Personal
  //       </button>
  //       <button
  //         className="button_inactive border padding_5 rounded_5 text_blue"
  //         data-mapid="clickCompany"
  //         onClick={() => handle_mode("company")}
  //       >
  //         Company
  //       </button>
  //     </section>
  //   </div>
  // );

  // let main_content = default_content;
  // if (mode !== "none") {
  //   main_content = register_content;
  // }

  let main_content = register_content;
  const text_collab_confirmation_content = dict[
    "You are signed as _username_. Are you sure you want to join to _creator_'s collaboration as _username_?"
  ][language]
    .replaceAll("_username_", your_name)
    .replace(
      "_creator_",
      collaborators?.user?.full_name || collaborators?.user?.name,
    );
  const modal_collab_confirmation_content = modal_collab_confirmation && (
    <Modal
      modalSize="small"
      isOpen={modal_collab_confirmation}
      onClose={() => {
        dispatch(logoutUser());
        toggle_modal_collab_confirmation();
      }}
      title="CONFIRMATION"
      content={<p>{text_collab_confirmation_content}</p>}
      footer={
        <>
          <Button onClick={() => join_collab_by_token()} variant="contained">
            Yes
          </Button>
          <Button
            onClick={() => {
              dispatch(logoutUser());
              toggle_modal_collab_confirmation();
            }}
            variant="outlined"
          >
            No
          </Button>
        </>
      }
    />
  );

  const text_you_already_member_content = dict[
    "You are signed as _username_. You are already a member of the _creator_'s collaboration."
  ][language]
    .replaceAll("_username_", your_name)
    .replace(
      "_creator_",
      collaborators?.user?.full_name || collaborators?.user?.name,
    );
  const you_already_member_content = modal_you_already_member && (
    <Modal
      modalSize="small"
      isOpen={modal_you_already_member}
      onClose={toggle_modal_you_already_member}
      title="INFORMATION"
      content={<p>{text_you_already_member_content}</p>}
      footer={
        <>
          <Button onClick={() => redirect_to_dashboard()} variant="contained">
            Ok
          </Button>
        </>
      }
    />
  );

  const text_full_member_content = dict[
    "The collaboration with _creator_ is already full."
  ][language].replace(
    "_creator_",
    collaborators?.user?.full_name || collaborators?.user?.name,
  );
  const modal_full_member_content = modal_full_member && (
    <Modal
      modalSize="small"
      isOpen={modal_full_member}
      onClose={toggle_modal_full_member}
      title="CAUTION"
      content={<p>{text_full_member_content}</p>}
      footer={
        <>
          <Button onClick={toggle_modal_full_member} variant="contained">
            OK
          </Button>
        </>
      }
    />
  );

  return (
    <main>
      {main_content}
      {modal_collab_confirmation_content}
      {modal_full_member_content}
      {you_already_member_content}
    </main>
  );
};

export default Register;
